import React from "react";
import tl from "../../svgs/gameflow/lines/tl.svg";
import tr from "../../svgs/gameflow/lines/tr.svg";
import bl from "../../svgs/gameflow/lines/bl.svg";
import br from "../../svgs/gameflow/lines/br.svg";
import l from "../../svgs/gameflow/lines/l.svg";
import r from "../../svgs/gameflow/lines/r.svg";

export default function Lines() {
  return (
    <>
      <div className="absolute top-10 left-10">
        <img src={tl} alt="tl" />
      </div>

      <div className="absolute top-10 -right-28">
        <img src={tr} alt="tr" />
      </div>

      <div className="absolute -bottom-10 left-36 ">
        <img src={bl} alt="bl" />
      </div>

      <div className="absolute bottom-10 xl:right-0 right-10">
        <img src={br} alt="br" />
      </div>

      <div className="absolute top-[30%] xl:-left-20 xl:scale-100 -left-4 scale-75">
        <img src={l} alt="l" />
      </div>

      <div className="absolute top-[60%] xl:right-0 right-10 ">
        <img src={r} alt="r" />
      </div>
    </>
  );
}
